(function () {
  const KEY = "wcd_wishlist_v1";

  function getList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  }

  function setList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("wcd:wishlist:changed", { detail: list }));
  }

  function has(handle) {
    return getList().includes(handle);
  }

  function toggle(handle) {
    const list = getList();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    else list.push(handle);
    setList(list);
    return list;
  }

  function syncButton(btn) {
    const handle = btn.getAttribute("data-wcd-handle");
    const active = has(handle);
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    //const icon = btn.querySelector(".wcd-wl-icon");
    //if (icon) icon.innerHTML = active ? "&#10084;" : "&#9825;"; // ♥ / ♡
  }

  function init(root = document) {
    /*function block(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }*/
   function stopOnly(e) {
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    function doToggle(btn, e) {
      e.preventDefault();     // aqui sim
      stopOnly(e);
      toggle(btn.getAttribute("data-wcd-handle"));
      syncButton(btn);
    }

    root.querySelectorAll("[data-wcd-wishlist-btn]").forEach(btn => {
        if (btn.__wcdBound) return;
        btn.__wcdBound = true;

        syncButton(btn);

         btn.addEventListener("touchstart", stopOnly, { capture: true, passive: true });

        // iOS: garante o toggle no touchend
        btn.addEventListener("touchend", (e) => doToggle(btn, e), { capture: true, passive: false });

        // desktop/geral
        btn.addEventListener("click", (e) => doToggle(btn, e), true);
    });

  }

  window.WCDWishlist = { getList, setList, has, toggle, init };

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (e) => init(e.target));

  window.addEventListener("wcd:wishlist:changed", () => {
    document.querySelectorAll("[data-wcd-wishlist-btn]").forEach(syncButton);
  });
})();
